const btnFormEquip = {
  text: 'nuevo servicio'
};

export default btnFormEquip;
